import _ from 'lodash';
import Immutable from 'immutable';
import tableMapper from '../../components/search/results/tableMapper';
import { createReducer } from '../utils';
import * as types from '../actionTypes/pacerSearchActionTypes';


function parsePageUrl(url) {
  const splitPage = url.split('page=');

  if (splitPage && splitPage.length > 1) {
    return splitPage[1].split('&')[0];
  }

  return null;
}

function mapSearchOptions(searchOptions) {
  const pages = _.map(searchOptions.pages, (url, key) => {
    if (key === 'next') {
      return {
        page: 'Next',
        nextPage: parsePageUrl(url),
      };
    }
    if (key === 'previous') {
      return {
        page: 'Previous',
        nextPage: parsePageUrl(url),
      };
    }

    return {
      page: parseInt(key, 10),
      url,
      active: _.isEmpty(url),
    };
  });

  return Object.assign({}, searchOptions, { pages: _.sortBy(pages, 'page') });
}

const initPacerSearchResults = Immutable.fromJS({
  data: [],
  receipts: [],
  searchOptions: {},
  filters: {
    case_type: 'Bankruptcy',

    court_id: null,
    case_no: null,
    case_title: null,
    chapter: null,
    filed_from: null,
    filed_to: null,
    closed_from: null,
    closed_to: null,
    dismissed_from: null,
    dismissed_to: null,
    discharged_from: null,
    discharged_to: null,
    nos: null,
    ssn4: null,
    ssntin: null,

    party_name: null,
    last_business_name: null,
    middle_name: null,
    first_name: null,
  },
});

export default createReducer(initPacerSearchResults, {
  [types.RECEIVE_SEARCH_RESULTS]: (state, action) => {
    let headerFields = [];
    let data = [];
    let searchResultsType = 'empty';
    const searchType = state.get('searchType');

    if (!_.isEmpty(action.searchResults.cases)) {
      // result type cases
      data = action.searchResults.cases;
      headerFields = tableMapper[searchType].casesHeaderFields;
      searchResultsType = 'cases';
    } else if (!_.isEmpty(action.searchResults.parties)) {
      // result type parties
      data = action.searchResults.parties;
      headerFields = tableMapper[searchType].partiesHeaderFields;
      searchResultsType = 'parties';
    }

    return state.merge({
      searchResultsType,
      data,
      headerFields,
      receipts: attach_source_id_to_receipts(action.searchResults.receipts, action.source_data_id),
      searchOptions: mapSearchOptions(action.searchOptions),
    });
  },
  [types.RESET_SEARCH_RESULTS]: () => initPacerSearchResults,
  [types.UPDATE_FILTER]: (state, action) => state.mergeDeep({ filters: action.filter }),
  [types.RESET_FILTERS]: () => initPacerSearchResults,
  [types.REQUEST_VIEW_SEARCH]: state => state,
  [types.REQUEST_BANKRUPTCY_SEARCH]: state => initPacerSearchResults.mergeDeep({
    filters: state.get('filters'),
    searchType: 'Bankruptcy',
    query_type: 'search',
  }),
  [types.REQUEST_BANKRUPTCY_LOCAL_SEARCH]: state => initPacerSearchResults.mergeDeep({
    filters: state.get('filters'),
    searchType: 'Bankruptcy',
    query_type: 'search',
  }),
  [types.REQUEST_CIVIL_SEARCH]: state => initPacerSearchResults.mergeDeep({
    filters: state.get('filters'),
    searchType: 'Civil',
    query_type: 'search_cv',
  }),
  [types.REQUEST_CRIMINAL_SEARCH]: state => initPacerSearchResults.mergeDeep({
    filters: state.get('filters'),
    searchType: 'Criminal',
    query_type: 'search_cr',
  }),

  [types.REQUEST_APPELLATE_SEARCH]: state => initPacerSearchResults.mergeDeep({
    filters: state.get('filters'),
    searchType: 'Appellate',
    query_type: 'search_appellate',
  }),
});

function attach_source_id_to_receipts(receipts, source_data_id) {
  if ( ! receipts ) return [];

  try {
    receipts[0].text.source_data_id = source_data_id;
  } catch (and_ignore_errors){ }

  return receipts;
}


// WEBPACK FOOTER //
// ./src/redux/reducers/pacerSearchResults.js